import { Props } from './BillToRadioCard'

import { Theme } from '@mui/material/styles'

export const getStyles = (props: Props, theme: Theme) => ({
  card: {
    background: props.checked ? '#F4F8FA' : theme.palette.common.white,
    border: '1px solid #E2E2E2',
    borderRadius: '4px',
    boxShadow: '0px 2px 6px rgba(194, 194, 194, 0.5)',
    color: theme.palette.text.primary,
    fontFamily: 'Source Sans Pro',
    fontSize: '14px',
    margin: `0 auto ${theme.spacing(1.2)} auto`,
    padding: theme.spacing(0.8),
    width: 'auto',
    '& p': {
      lineHeight: 'var(--lineHeight)',
    },
  },

  expandLink: {
    color: '#005aa3',
    cursor: 'pointer',
  },

  variantLabel: {
    fontFamily: 'Source Sans Pro Semibold',
  },
})
